import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../services/portalService";

export const getOrders = createAsyncThunk(
  "portal/orders/list",
  async (_, { getState }) => {
    try {
      const state: any = getState();
      const {
        page,
        pageSize,
        searchQuery,
        categoryFilter,
        sortBy,
        requestType,
        subOrganizationFilter,
      } = state.portal;

      const queryParams = new URLSearchParams();

      // Pagination
      queryParams.append("page", page.toString());
      queryParams.append("pageSize", pageSize.toString());

      // Search
      if (searchQuery.trim()) {
        queryParams.append("search", searchQuery.trim());
      }

      // Category/status filter
      if (categoryFilter !== "all") {
        queryParams.append("status", categoryFilter);
      }

      if (subOrganizationFilter && subOrganizationFilter !== "all") {
        queryParams.append("subOrganization", subOrganizationFilter);
      }

      // Sorting
      switch (sortBy) {
        case "name-asc":
          queryParams.append("sort", "name");
          queryParams.append("order", "asc");
          break;
        case "name-desc":
          queryParams.append("sort", "name");
          queryParams.append("order", "desc");
          break;
        case "created-asc":
          queryParams.append("sort", "createdAt");
          queryParams.append("order", "asc");
          break;
        case "created-desc":
        default:
          queryParams.append("sort", "createdAt");
          queryParams.append("order", "desc");
          break;
      }

      if (requestType !== "all") {
        queryParams.append("requestType", requestType);
      }

      const response = await API.getPortalSalesOrder(queryParams);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);
